<template>
  <div class="game-layout-new">
    <!-- 主内容区域 -->
    <div class="main-content">
      
      <!-- 顶部区域 -->
      <div class="top-header">
        <div class="brand-info">
          <div class="logo-area" @click="changleftshow">
            <img :src="$store.state.appInfo.site_logo || defaultLogo" />
          </div>
          <div class="app-rating">
            <div class="star-group">
              <span class="star" v-for="n in 5" :key="n">★</span>
            </div>
            <span class="rating-text">{{ $store.state.appInfo.title || '全球娱乐' }}</span>
          </div>
        </div>
        <div class="action-buttons">
          <button class="icon-btn" @click="toggleLangDropdown">
            <img class="lang-img" :src="currentLangImg" />
          </button>
          <button class="icon-btn" @click="$parent.openKefu">
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </button>
          <button class="icon-btn" @click="$parent.goNav('/message')">
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
              <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 语言下拉菜单 -->
      <div class="lang-dropdown" v-if="langDropdownOpen">
        <div v-for="lang in languages" :key="lang.code" class="lang-option" :class="{ active: currentLang === lang.code }" @click="setLanguage(lang.code)">
          {{ lang.name }}
        </div>
      </div>

      <!-- 轮播图 -->
      <div class="banner-area" v-if="bannerList && bannerList.length">
        <div class="banner-swiper">
          <div class="banner-wrapper" :style="{ transform: 'translateX(-' + (bannerIndex * 100) + '%)' }">
            <div v-for="(item, idx) in bannerList" :key="idx" class="banner-slide" @click="$parent.goNav(item.url)">
              <img :src="item.src" class="banner-img" />
            </div>
          </div>
          <div class="banner-dots">
            <span v-for="(item, idx) in bannerList" :key="idx" class="dot" :class="{ active: bannerIndex === idx }" @click="bannerIndex = idx"></span>
          </div>
        </div>
      </div>

      <!-- 登录/注册按钮区域 -->
      <div class="auth-buttons" v-if="!$store.state.token">
        <button class="login-btn" @click="showLogin = true">{{ $t('login') }}</button>
        <button class="register-btn" @click="showRegister = true">{{ $t('register') }}</button>
       <!-- <div class="function-btn" @click="$parent.goNav('/share')">
          <div class="btn-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg></div>
          <span>{{ $t('share_earn') || '分享赚钱' }}</span> 
        </div> -->
        <div class="function-btn" @click="$parent.openKefu">
          <div class="btn-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path></svg></div>
          <span>{{ $t('customer_service') || '在线客服' }}</span>
        </div>
      </div>

      <!-- 用户卡片 (已登录状态) -->
      <div class="user-card" v-else-if="$store.state.token">
        <div class="balance-row">
          <div class="balance-info">
            <span class="currency">U</span>
            <span class="balance">{{ showBalance ? $store.getters.safeBalance : '****' }}</span>
            <i class="eye-icon" @click="toggleBalanceVisibility">👁</i>
            <i class="refresh-icon" :class="{ spinning: isRefreshing }" @click="refreshBalance">⟳</i>
          </div>
          <div class="balance-actions">
            <div class="balance-action-btn" @click="$parent.goNav('/recharge')">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              {{ $t('deposit') || '充值' }}
            </div>
            <div class="balance-action-btn" @click="$parent.goNav('/withdrawal')">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                <rect x="6" y="8" width="12" height="12" rx="1"/>
              </svg>
              {{ $t('withdraw') || '提现' }}
            </div>
          </div>
        </div>
      </div>

      <!-- 热门推荐标题栏 -->
      <div class="section-header">
        <div class="header-line"></div>
        <div class="header-title">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#3b82f6" stroke="currentColor" stroke-width="2">
            <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
          </svg>
          <span>{{ $t('hot_recommend') || '火爆推荐' }}</span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#3b82f6" stroke="currentColor" stroke-width="2">
            <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
          </svg>
        </div>
        <div class="header-line"></div>
      </div>

      <!-- 左右双栏布局 -->
      <div class="two-column-layout">
        <!-- 左侧分类导航栏 -->
        <div class="category-sidebar">
          <div class="category-item" :class="{ active: gameType == 6 }" @click="changGameType(6)">
            <div class="category-icon"><img src="/static/images/hot_icon.png" /></div>
            <span>{{ $t('hot') || '热门' }}</span>
          </div>
          <div class="category-item" :class="{ active: gameType == 4 }" @click="changGameType(4)">
            <div class="category-icon"><img src="/static/images/slot_icon.png" /></div>
            <span>{{ $t('slot') || '电子' }}</span>
          </div>
          <div class="category-item" :class="{ active: gameType == 0 }" @click="changGameType(0)">
            <div class="category-icon"><img src="/static/images/live_icon.png" /></div>
            <span>{{ $t('live') || '真人' }}</span>
          </div>
          <div class="category-item" :class="{ active: gameType == 5 }" @click="changGameType(5)">
            <div class="category-icon"><img src="/static/images/lottery_icon.png" /></div>
            <span>{{ $t('lottery') || '彩票' }}</span>
          </div>
          <div class="category-item" :class="{ active: gameType == 3 }" @click="changGameType(3)">
            <div class="category-icon"><img src="/static/images/card_icon.png" /></div>
            <span>{{ $t('card') || '棋牌' }}</span>
          </div>
          <div class="category-item" :class="{ active: gameType == 1 }" @click="changGameType(1)">
            <div class="category-icon"><img src="/static/images/sport_icon.png" /></div>
            <span>{{ $t('sport') || '体育' }}</span>
          </div>
          <div class="category-item" :class="{ active: gameType == 2 }" @click="changGameType(2)">
            <div class="category-icon"><img src="/static/images/fishing_icon.png" /></div>
            <span>{{ $t('fishing') || '捕鱼' }}</span>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div class="content-area">
          <!-- 热门游戏：显示子游戏列表 -->
          <div class="game-grid-3" v-if="gameType == 6">
            <div v-for="(item, index) in hotGameList" :key="index" class="game-item" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
              <div class="game-img-wrap">
                <img :src="getGameImg(item, 'hot')" class="game-img" />
                <div class="hot-badge" v-if="index < 3">🔥</div>
              </div>
              <div class="game-name">{{ (item.name || item.game_name || '').slice(0, 12) }}</div>
            </div>
            <div v-if="loadingMore" class="loading-more">加载更多...</div>
          </div>

          <!-- 电子：显示平台大厅 -->
          <div class="platform-grid" v-if="gameType == 4">
            <div v-for="(item, index) in slotPlatformList" :key="index" class="platform-card" @click="enterPlatform(item, 'slot')">
              <img :src="item.mobile_img || getPlatformImg(item.platform_code, 'slot')" />
              <span>{{ item.platform_name }}</span>
            </div>
            <div v-if="!slotPlatformList.length" class="empty-tip">暂无平台</div>
          </div>

          <!-- 视讯：显示平台大厅 -->
          <div class="platform-grid" v-if="gameType == 0">
            <div v-for="(item, index) in realbetPlatformList" :key="index" class="platform-card" @click="enterPlatform(item, 'realbet')">
              <img :src="item.mobile_img || getPlatformImg(item.platform_code, 'realbet')" />
              <span>{{ item.platform_name }}</span>
            </div>
            <div v-if="!realbetPlatformList.length" class="empty-tip">暂无平台</div>
          </div>

          <!-- 体育：显示平台大厅 -->
          <div class="platform-grid" v-if="gameType == 1">
            <div v-for="(item, index) in sportPlatformList" :key="index" class="platform-card" @click="enterPlatform(item, 'sport')">
              <img :src="item.mobile_img || getPlatformImg(item.platform_code, 'sport')" />
              <span>{{ item.platform_name }}</span>
            </div>
            <div v-if="!sportPlatformList.length" class="empty-tip">暂无平台</div>
          </div>

          <!-- 捕鱼：显示平台大厅 -->
          <div class="platform-grid" v-if="gameType == 2">
            <div v-for="(item, index) in fishingPlatformList" :key="index" class="platform-card" @click="enterPlatform(item, 'fishing')">
              <img :src="item.mobile_img || getPlatformImg(item.platform_code, 'fishing')" />
              <span>{{ item.platform_name }}</span>
            </div>
            <div v-if="!fishingPlatformList.length" class="empty-tip">暂无平台</div>
          </div>

          <!-- 棋牌：显示平台大厅 -->
          <div class="platform-grid" v-if="gameType == 3">
            <div v-for="(item, index) in jokerPlatformList" :key="index" class="platform-card" @click="enterPlatform(item, 'joker')">
              <img :src="item.mobile_img || getPlatformImg(item.platform_code, 'joker')" />
              <span>{{ item.platform_name }}</span>
            </div>
            <div v-if="!jokerPlatformList.length" class="empty-tip">暂无平台</div>
          </div>

          <!-- 彩票：显示平台大厅 -->
          <div class="platform-grid" v-if="gameType == 5">
            <div v-for="(item, index) in lotteryPlatformList" :key="index" class="platform-card" @click="enterPlatform(item, 'lottery')">
              <img :src="item.mobile_img || getPlatformImg(item.platform_code, 'lottery')" />
              <span>{{ item.platform_name }}</span>
            </div>
            <div v-if="!lotteryPlatformList.length" class="empty-tip">暂无平台</div>
          </div>
        </div>
      </div>

    </div>

    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div class="nav-item" :class="{ active: gameType == 6 }" @click="changGameType(6)">
        <img :src="`/static/style/${gameType == 6 ? 'sidebar_casino_icon_select' : 'sidebar_casino_icon_nor'}.png`" />
        <span>{{ $t('hot') }}</span>
      </div>
      <div class="nav-item" :class="{ active: gameType == 4 }" @click="changGameType(4)">
        <img :src="`/static/style/${gameType == 4 ? 'sidebar_slot_icon_select' : 'sidebar_slot_icon_nor'}.png`" />
        <span>{{ $t('slot') }}</span>
      </div>
      <div class="nav-item" :class="{ active: gameType == 0 }" @click="changGameType(0)">
        <img :src="`/static/style/${gameType == 0 ? 'sidebar_casino_icon_select' : 'sidebar_casino_icon_nor'}.png`" />
        <span>{{ $t('live') }}</span>
      </div>
      <div class="nav-item" :class="{ active: gameType == 1 }" @click="changGameType(1)">
        <img :src="`/static/style/${gameType == 1 ? 'sidebar_sports_icon_select' : 'sidebar_sports_icon_nor'}.png`" />
        <span>{{ $t('sport') }}</span>
      </div>
      <div class="nav-item" @click="$parent.goNav('/share')">
        <img src="/static/style/share-icon.png" />
        <span>{{ $t('share_earn') || '赚钱' }}</span>
      </div>
    </div>

    <!-- 侧边栏菜单 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%', width: '80%' }">
      <div class="side-panel">
        <h3>{{ $t('welcome') }}{{ $store.state.appInfo.title }}</h3>
        <div class="vip-section">
          <div class="vip-title">{{ $t('exclusive_vip_experience') }}</div>
          <p>{{ $t('enjoy_member_privileges') }}</p>
          <p>{{ $t('enjoy_unique_experience') }}</p>
          <div class="vip-btn" @click="$parent.goNav('/vip')">{{ $t('member_center') }}</div>
        </div>
        <ul class="side-menu-list">
          <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" /><span>{{ $t('message_center') }}</span></li>
          <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" /><span>{{ $t('feedback') }}</span></li>
          <li @click="doCopy($store.state.appInfo.h5_url)"><img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" /><span>{{ $t('permanent_domain') }}</span><span class="domain-text">{{ $store.state.appInfo.h5_url }}</span></li>
          <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" /><span>{{ $t('about_us') }}</span></li>
        </ul>
        <div class="logout-btn" v-if="!$store.state.token" @click="$parent.goNav('/login')">{{ $t('login_now') }}</div>
        <div class="logout-btn" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" /><span>{{ $t('safe_logout') }}</span></div>
      </div>
    </van-popup>

    <!-- 弹窗 -->
    <div v-if="goInfo" class="modal-mask" @click="goInfo = null">
      <div class="modal-container">
        <img src="/static/image/hongbaocolse.png" class="modal-close" @click="goInfo = null" />
        <div class="modal-body">{{ goInfo }}</div>
        <button class="modal-btn" @click="$parent.goNav('/message')">{{ $t('more_notice') }}</button>
      </div>
    </div>

    <div v-if="$store.state.appInfo.index_modal == 1 && tanshow" class="modal-mask" @click="changtanshow">
      <div class="modal-container">
        <img src="/static/image/hongbaocolse.png" class="modal-close" @click="changtanshow" />
        <div class="modal-body" v-html="$store.state.appInfo.webcontent"></div>
      </div>
    </div>

    <!-- 登录注册弹窗 -->
    <div v-if="showLogin" class="modal-mask" @click="showLogin = false">
      <div class="modal-container" @click.stop><login @close="showLogin = false" /></div>
    </div>
    <div v-if="showRegister" class="modal-mask" @click="showRegister = false">
      <div class="modal-container" @click.stop><login @close="showRegister = false" :initial-type="1" /></div>
    </div>
  </div>
</template>

<script>
import login from '../login.vue';

export default {
  name: 'index',
  components: { login },
  data() {
    return {
      bannerList: [],
      homenoticelis: [],
      leftshow: false,
      gameType: 6,
      tanshow: true,
      goInfo: null,
      showLogin: false,
      showRegister: false,
      isRefreshing: false,
      showSearch: false,
      searchKeyword: '',
      filteredGames: [],
      selectedPlatform: '',
      selectedFishingPlatform: '',
      filteredFishingGames: [],
      selectedJokerPlatform: '',
      filteredJokerGames: [],
      selectedLotteryPlatform: '',
      filteredLotteryGames: [],
      bannerIndex: 0,
      bannerTimer: null,
      showSubGames: false,
      slotPlatformList: [],
      fishingPlatformList: [],
      jokerPlatformList: [],
      lotteryPlatformList: [],
      realbetPlatformList: [],
      sportPlatformList: [],
      platformConfigs: {
        concise: [],
        gaming: [],
        joker: [],
        realbet: [],
        sport: [],
        lottery: []
      },
      langDropdownOpen: false,
      showBalance: true,
      defaultLogo: '/static/image/logo.jpeg',
      domainText: 'yongli88.top',
      languages: [
        { code: 'zh', name: '中文', img: '/static/image/lang_zh.webp' },
        { code: 'tw', name: '繁體中文', img: '/static/image/lang_tw.webp' },
        { code: 'en', name: 'English', img: '/static/image/lang_en.webp' },
        { code: 'th', name: 'ภาษาไทย', img: '/static/image/lang_th.webp' },
        { code: 'pt', name: 'Português', img: '/static/image/lang_pt.webp' },
        { code: 'id', name: 'Indonesia', img: '/static/image/lang_id.webp' },
        { code: 'jp', name: '日本語', img: '/static/image/lang_jp.webp' },
        { code: 'kh', name: 'ភាសាខ្មែរ', img: '/static/image/lang_kh.webp' },
        { code: 'vi', name: 'Tiếng Việt', img: '/static/image/lang_vi.webp' },
        { code: 'kr', name: '한국어', img: '/static/image/lang_kr.webp' }
      ],
      hotTabActive: 0,
      loadingMore: false,
      hotGamePage: 1,
      hotGameHasMore: true
    };
  },
  computed: {
    currentLang() {
      return localStorage.getItem('language') || 'zh';
    },
    currentLangImg() {
      var lang = this.languages.find(function(l) { return l.code === this.currentLang; }.bind(this));
      return lang ? lang.img : '/static/image/lang_zh.png';
    },
    userName: function() {
      var user = this.$store.state.userInfo || {};
      return user.username || user.userid || user.id || user.user_id || user.account || user.name || user.nickname || user.user_name || '游客';
    },
    userVip: function() {
      var user = this.$store.state.userInfo;
      return user ? (user.vip || 0) : 0;
    },
    // 热门游戏列表 - 合并多个数据源
hotGameList: function() {
  var allGames = [];
  
  if (this.$store.state.fishingList && this.$store.state.fishingList.length) {
    allGames = allGames.concat(this.$store.state.fishingList);
  }
  if (this.$store.state.conciseList && this.$store.state.conciseList.length) {
    allGames = allGames.concat(this.$store.state.conciseList);
  }
  if (this.$store.state.jokerList && this.$store.state.jokerList.length) {
    allGames = allGames.concat(this.$store.state.jokerList);
  }
  // ✅ 添加彩票数据
  if (this.$store.state.lotteryList && this.$store.state.lotteryList.length) {
    allGames = allGames.concat(this.$store.state.lotteryList);
  }
  
  // 去重
  var uniqueGames = [];
  var seenCodes = new Set();
  for (var i = 0; i < allGames.length; i++) {
    var game = allGames[i];
    var code = game.game_code || game.id || i;
    if (!seenCodes.has(code)) {
      seenCodes.add(code);
      uniqueGames.push(game);
    }
  }
  
  return uniqueGames;
}
  },
  created: function() {
    this.getBanList();
    this.homenotice();
    this.getPlatformConfigs();
    this.getGameListWithLang();
  },
  mounted: function() {
    this.startBannerAutoPlay();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy: function() {
    if (this.bannerTimer) clearInterval(this.bannerTimer);
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    gameType: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showSubGames = false;
        this.resetFilters();
      }
    },
    '$store.state.conciseList': {
      handler: function() { this.initPlatformLists(); },
      deep: true
    },
    '$store.state.gamingList': {
      handler: function() { this.initPlatformLists(); },
      deep: true
    },
    '$store.state.jokerList': {
      handler: function() { this.initPlatformLists(); },
      deep: true
    }
  },
  methods: {
    formatNumber(num) {
      if (!num) return '0';
      return num.toLocaleString();
    },
    startBannerAutoPlay: function() {
      var that = this;
      that.bannerTimer = setInterval(function() {
        if (that.bannerList && that.bannerList.length) {
          that.bannerIndex = (that.bannerIndex + 1) % that.bannerList.length;
        }
      }, 3000);
    },
    handleClickOutside: function(e) {
      var switchEl = this.$el.querySelector('.lang-switch');
      if (switchEl && !switchEl.contains(e.target)) {
        this.langDropdownOpen = false;
      }
    },
    toggleLangDropdown: function() {
      this.langDropdownOpen = !this.langDropdownOpen;
    },
    setLanguage: function(lang) {
      localStorage.setItem('language', lang);
      this.langDropdownOpen = false;
      if (this.$i18n) {
        this.$i18n.locale = lang;
      }
      // 重新获取多语言数据
      this.getPlatformConfigs();
      this.getGameListWithLang();
    },
    toggleBalanceVisibility: function() {
      this.showBalance = !this.showBalance;
    },
    changtanshow: function() { this.tanshow = false; },
    changleftshow: function() { this.leftshow = true; },
    changGameType: function(type) {
      this.gameType = type;
      this.showSubGames = false;
      this.resetFilters();
      var that = this;
      this.$nextTick(function() { that.initPlatformLists(); });
    },
    resetFilters: function() {
      this.selectedPlatform = '';
      this.selectedFishingPlatform = '';
      this.selectedJokerPlatform = '';
      this.selectedLotteryPlatform = '';
      this.filteredGames = [];
      this.filteredFishingGames = [];
      this.filteredJokerGames = [];
      this.filteredLotteryGames = [];
      this.searchKeyword = '';
      this.showSearch = false;
    },
    showMoreGames: function() { this.$parent.goNav('/game-list'); },
    handleGameClick: function(item) { this.$parent.openGamePage(item.platform_name, item.game_code, '', item.name); },
    getPlatformConfigs: async function() {
      try {
        var lang = localStorage.getItem('language') || 'zh';
        var currency = lang.toUpperCase();
        var res = await this.$apiFun.post('/api/getPlatformList', { currency: currency });
        if (res.code == 200) {
          this.platformConfigs = res.data;
          this.initPlatformLists();
        }
      } catch (error) {
        console.error('获取平台配置失败:', error);
      }
    },
    // 获取多语言游戏列表
    getGameListWithLang: async function() {
      try {
        var lang = localStorage.getItem('language') || 'zh';
        var currency = '';
        switch(lang) {
          case 'zh': currency = 'ZH'; break;
          case 'tw': currency = 'TW'; break;
          case 'en': currency = 'EN'; break;
          case 'th': currency = 'TH'; break;
          case 'pt': currency = 'BR'; break;
          case 'id': currency = 'ID'; break;
          case 'jp': currency = 'JP'; break;
          case 'kh': currency = 'KH'; break;
          case 'vi': currency = 'VI'; break;
          case 'kr': currency = 'KR'; break;
          default: currency = 'ZH';
        }
        
      var res = await this.$apiFun.post('/api/game/list', { currency: currency });
        if (res.code == 200 && res.data) {
          var conciseList = res.data.filter(item => item.category_id == 'concise');
          var fishingList = res.data.filter(item => item.category_id == 'fishing');
          var jokerList = res.data.filter(item => item.category_id == 'joker');
          var realbetList = res.data.filter(item => item.category_id == 'realbet');
          var sportList = res.data.filter(item => item.category_id == 'sport');
          var lotteryList = res.data.filter(item => item.category_id == 'lottery');
          
          this.$store.commit('setConciseList', conciseList);
          this.$store.commit('setFishingList', fishingList);
          this.$store.commit('setJokerList', jokerList);
          this.$store.commit('setRealbetList', realbetList);
          this.$store.commit('setSportList', sportList);
          this.$store.commit('setLotteryList', lotteryList);
        }
      } catch (error) {
        console.error('获取游戏列表失败:', error);
      }
    },
initPlatformLists: function() {
  this.slotPlatformList = this.platformConfigs.concise || [];
  this.fishingPlatformList = this.platformConfigs.gaming || [];
  this.jokerPlatformList = this.platformConfigs.joker || [];
  this.realbetPlatformList = this.platformConfigs.realbet || [];
  this.sportPlatformList = this.platformConfigs.sport || [];
  
  // ✅ 彩票也从 platformConfigs 获取
  this.lotteryPlatformList = this.platformConfigs.lottery || [];
  
  // 注释掉原来的彩票获取方式
  // var lotteryAll = (this.$store.state.lhcList || []).concat(
  //   this.$store.state.jscList || [],
  //   this.$store.state.jwcList || [],
  //   this.$store.state.qkcList || []
  // );
  // this.lotteryPlatformList = this.getUniquePlatforms(lotteryAll);
},
    getUniquePlatforms: function(gameList) {
      var platformMap = new Map();
      gameList.forEach(function(game) {
        var platformName = game.platform_name;
        if (platformName && !platformMap.has(platformName)) {
          platformMap.set(platformName, {
            platform_name: platformName,
            platform_code: game.platform_code || platformName,
            game_code: game.game_code,
            mobile_img: game.mobile_img,
            api_logo_img: game.api_logo_img
          });
        }
      });
      return Array.from(platformMap.values());
    },
    enterPlatform: function(platform, type) {
      this.$parent.openGamePage(platform.platform_code, '0', '0', platform.platform_name + '大厅', true);
    },
    getGameImg: function(item, type) {
      var baseURL = sessionStorage.getItem('baseURL') || 'http://127.0.0.13';
      var imgSrc = '';
      var imgFields = ['mobile_img', 'api_logo_img', 'app_img', 'img', 'image', 'icon', 'game_img', 'logo'];
      for (var i = 0; i < imgFields.length; i++) {
        var field = imgFields[i];
        if (item[field] && item[field].trim()) {
          imgSrc = item[field].trim();
          break;
        }
      }
      if (imgSrc) {
        if (imgSrc.indexOf('/uploads/http') !== -1) {
          var match = imgSrc.match(/\/uploads\/(https?:\/\/.*)/);
          if (match) return match[1];
        }
        if (imgSrc.indexOf('http') === 0) return imgSrc;
        if (imgSrc.indexOf('/') === 0) return baseURL + imgSrc;
        return baseURL + '/' + imgSrc;
      }
      return '';
    },
    getPlatformImg: function(platformCode, type) {
      var imgMap = {
        'PG': '/static/platform/pg_banner.jpg',
        'PP': '/static/platform/pp_banner.jpg',
        'CQ9': '/static/platform/cq9_banner.jpg',
        'JDB': '/static/platform/jdb_banner.jpg',
        'JILI': '/static/platform/jili_banner.jpg',
        'FC': '/static/platform/fc_banner.jpg',
        'WG': '/static/platform/wg_banner.jpg',
        'BGBY': '/static/platform/bg_fishing_banner.jpg',
        'AG': '/static/platform/ag_fishing_banner.jpg',
        'BBQP': '/static/platform/bbqp_banner.jpg',
        'BGQP': '/static/platform/bgqp_banner.jpg',
        'LHC': '/static/platform/lhc_banner.jpg',
        'JSC': '/static/platform/jsc_banner.jpg',
        'JWC': '/static/platform/jwc_banner.jpg',
        'QKC': '/static/platform/qkc_banner.jpg',
      };
      return imgMap[platformCode] || '/static/platform/default_banner.jpg';
    },
    doCopy: function(msg) {
      var input = document.createElement('input');
      input.value = msg;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      this.$parent.showTost(1, this.$t('copy_success'));
    },
    refreshBalance: function() {
      var that = this;
      if (that.isRefreshing) return;
      that.isRefreshing = true;
      that.$apiFun.post('/api/balance', {}).then(function(res) {
        if (res.code == 200 && res.data) {
          var userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      }).finally(function() { that.isRefreshing = false; });
    },
    getBanList: function() {
      var that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/bannerList', { type: 2 }).then(function(res) {
        if (res.code == 200) {
          that.bannerList = res.data;
        }
        that.$parent.hideLoading();
      }).catch(function() {
        that.$parent.hideLoading();
      });
    },
    homenotice: function() {
      var that = this;
      that.$apiFun.post('/api/homenotice', {}).then(function(res) {
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }

html {
  font-size: 13.333vw;
}

.game-layout-new {
  background: #f1f5f9;
  min-height: 100vh;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  position: relative;
}

.main-content { 
  background: #f1f5f9;
  min-height: 100vh;
  padding-bottom: 1.2rem;
}

// 顶部区域
.top-header {
  background: #fff;
  padding: 0.2rem 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 99;
  
  .brand-info {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    flex: 1;
    
    .logo-area {
      img { 
        height: 0.7rem; 
        max-width: 2rem; 
        object-fit: contain; 
      }
    }
    
    .app-rating {
      .star-group {
        display: flex;
        gap: 0.04rem;
        
        .star {
          font-size: 0.28rem;
          color: #fbbf24;
        }
      }
      
      .rating-text {
        font-size: 0.24rem;
        color: #6b7280;
      }
    }
  }
  
  .action-buttons {
    display: flex;
    align-items: center;
    gap: 0.12rem;
    
    .icon-btn {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      background: #f3f4f6;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: none;
      
      .lang-img {
        width: 0.45rem;
        height: 0.45rem;
        border-radius: 50%;
      }
      
      svg {
        width: 0.4rem;
        height: 0.4rem;
        color: #6b7280;
      }
    }
  }
}

// 语言下拉菜单
.lang-dropdown {
  position: fixed;
  top: 1.2rem;
  right: 0.3rem;
  background: #fff;
  border-radius: 0.2rem;
  box-shadow: 0 0.1rem 0.4rem rgba(0,0,0,0.15);
  z-index: 100;
  min-width: 2rem;
  
  .lang-option {
    padding: 0.2rem 0.3rem;
    text-align: center;
    cursor: pointer;
    font-size: 0.32rem;
    
    &:hover { background: #f5f5f5; }
    &.active { background: #3b82f6; color: #fff; }
  }
}

// 轮播图
.banner-area {
  padding: 0 0.16rem;
  margin-top: 0.12rem;
  
  .banner-swiper {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 0.24rem;
    
    .banner-wrapper {
      display: flex;
      transition: transform 0.3s ease;
      
      .banner-slide {
        flex-shrink: 0;
        width: 100%;
        cursor: pointer;
        
        .banner-img {
          width: 100%;
          height: 3.6rem;
          object-fit: cover;
          display: block;
        }
      }
    }
    
    .banner-dots {
      position: absolute;
      bottom: 0.12rem;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      gap: 0.08rem;
      
      .dot {
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 50%;
        background: rgba(255,255,255,0.5);
        cursor: pointer;
        
        &.active {
          background: #3b82f6;
          width: 0.32rem;
          border-radius: 0.08rem;
        }
      }
    }
  }
}

// 登录注册按钮区域
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  margin: 0.16rem;
  padding: 0.16rem;
  background: #fff;
  border-radius: 0.3rem;
  
  .login-btn {
    flex: 2;
    padding: 0.2rem;
    border-radius: 0.5rem;
    background: transparent;
    border: 2px solid #3b82f6;
    color: #3b82f6;
    font-weight: bold;
    font-size: 0.32rem;
    cursor: pointer;
  }
  
  .register-btn {
    flex: 2;
    padding: 0.2rem;
    border-radius: 0.5rem;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: #fff;
    font-weight: bold;
    border: none;
    font-size: 0.32rem;
    cursor: pointer;
  }
  
  .function-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.04rem;
    cursor: pointer;
    flex: 1;
    
    .btn-icon {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      background: rgba(59,130,246,0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      
      svg { width: 0.32rem; height: 0.32rem; color: #3b82f6; }
    }
    
    span {
      font-size: 0.22rem;
      color: #6b7280;
    }
  }
}

// 用户卡片
.user-card {
  background: #fff;
  margin: 0.16rem;
  border-radius: 0.3rem;
  padding: 0.28rem;
  
  .balance-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.12rem;
  }
  
  .balance-info {
    display: flex;
    align-items: baseline;
    gap: 0.08rem;
    flex: 1;
    
    .currency { font-size: 0.36rem; color: #6b7280; }
    .balance { font-size: 0.6rem; font-weight: bold; color: #1f2937; }
    .eye-icon, .refresh-icon {
      margin-left: 0.08rem;
      font-size: 0.32rem;
      color: #9ca3af;
      cursor: pointer;
      font-style: normal;
    }
    .refresh-icon.spinning {
      animation: spin 1s linear infinite;
    }
  }
  
  .balance-actions {
    display: flex;
    gap: 0.12rem;
    
    .balance-action-btn {
      display: flex;
      align-items: center;
      gap: 0.06rem;
      padding: 0.1rem 0.24rem;
      border-radius: 0.5rem;
      background: linear-gradient(135deg, #3b82f6, #2563eb);
      color: #fff;
      font-size: 0.28rem;
      cursor: pointer;
      white-space: nowrap;
      
      svg {
        width: 0.32rem;
        height: 0.32rem;
        stroke: #fff;
      }
      
      &:active {
        transform: scale(0.95);
      }
    }
  }
}

// 区域标题
.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.16rem;
  margin: 0.24rem 0.16rem;
  
  .header-line {
    flex: 1;
    height: 1px;
    background: #e5e7eb;
  }
  
  .header-title {
    display: flex;
    align-items: center;
    gap: 0.08rem;
    
    span {
      font-weight: bold;
      font-size: 0.34rem;
      color: #1f2937;
    }
    
    svg { color: #3b82f6; }
  }
}

// 左右两栏布局
.two-column-layout {
  display: flex;
  gap: 0.08rem;
  margin: 0.12rem 0.16rem;
  min-height: 8rem;
  
  .category-sidebar {
    width: 1.3rem;
    flex-shrink: 0;
    background: #fff;
    border-radius: 0.24rem;
    overflow-y: auto;
    max-height: 10rem;
    position: sticky;
    top: 1rem;
    
    .category-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.2rem 0.08rem;
      cursor: pointer;
      transition: all 0.2s;
      
      &.active {
        background: rgba(59,130,246,0.05);
        position: relative;
        
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0.2rem;
          bottom: 0.2rem;
          width: 0.08rem;
          background: #3b82f6;
          border-radius: 0.04rem;
        }
        
        span { color: #3b82f6; font-weight: bold; }
      }
      
      .category-icon {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 0.16rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.08rem;
        
        img {
          width: 0.5rem;
          height: 0.5rem;
          object-fit: contain;
        }
      }
      
      span {
        font-size: 0.24rem;
        color: #6b7280;
      }
    }
  }
  
  .content-area {
    flex: 1;
    background: #fff;
    border-radius: 0.24rem;
    padding: 0.16rem;
  }
}

// 游戏网格
.game-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.12rem;
  max-height: 12rem;
  overflow-y: auto;
  
  .game-item {
    cursor: pointer;
    
    .game-img-wrap {
      position: relative;
      border-radius: 0.16rem;
      overflow: hidden;
      background: #f3f4f6;
      
      .game-img {
        width: 100%;
        aspect-ratio: 3/4;
        object-fit: cover;
        display: block;
      }
      
      .hot-badge {
        position: absolute;
        top: 0.06rem;
        left: 0.06rem;
        font-size: 0.24rem;
      }
    }
    
.game-name {
  margin-top: 0.08rem;
  text-align: center;
  font-size: 0.28rem;
  color: #4b5563;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;  /* 最多显示2行 */
  -webkit-box-orient: vertical;
  white-space: normal;     /* 允许换行 */
  word-break: break-word;  /* 长单词断行 */
  line-height: 1.3;
  min-height: 0.72rem;     /* 2行的高度 */
}
  }
}

.loading-more {
  grid-column: span 3;
  text-align: center;
  padding: 0.2rem;
  font-size: 0.28rem;
  color: #9ca3af;
}

// 平台网格
.platform-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.2rem;
  padding: 0.08rem;
}

.platform-card {
  text-align: center;
  cursor: pointer;
  
  img {
    width: 1.6rem;
    height: 2.2rem;
    border-radius: 0.2rem;
    object-fit: cover;
    background: #f3f4f6;
  }
  
  span {
    display: block;
    font-size: 0.28rem;
    color: #4b5563;
    margin-top: 0.08rem;
  }
}

.empty-tip {
  text-align: center;
  padding: 1rem;
  font-size: 0.36rem;
  color: #9ca3af;
  grid-column: span 3;
}

// 底部导航
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  padding: 0.08rem 0 0.16rem;
  background: rgba(255,255,255,0.96);
  backdrop-filter: blur(10px);
  box-shadow: 0 -0.04rem 0.16rem rgba(0,0,0,0.05);
  z-index: 99;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  
  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.04rem;
    cursor: pointer;
    
    img { width: 0.5rem; height: 0.5rem; object-fit: contain; }
    span { font-size: 0.24rem; color: #9ca3af; }
    
    &.active span { color: #3b82f6; font-weight: bold; }
  }
}

// 侧边栏
.side-panel {
  padding: 0.4rem;
  height: 100%;
  background: #fff;
  
  h3 { font-size: 0.44rem; margin-bottom: 0.32rem; }
  
  .vip-section {
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    border-radius: 0.2rem;
    padding: 0.28rem;
    color: #fff;
    margin-bottom: 0.44rem;
    position: relative;
    
    .vip-title { font-size: 0.4rem; font-weight: bold; }
    p { font-size: 0.28rem; opacity: 0.8; margin-top: 0.06rem; }
    .vip-btn {
      position: absolute;
      top: 0.28rem;
      right: 0.28rem;
      border: 1px solid #fff;
      border-radius: 0.6rem;
      padding: 0.06rem 0.2rem;
      font-size: 0.28rem;
      cursor: pointer;
    }
  }
  
  .side-menu-list li {
    display: flex;
    align-items: center;
    padding: 0.24rem 0;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    
    img { width: 0.5rem; margin-right: 0.24rem; object-fit: contain; }
    span { font-size: 0.32rem; color: #666; flex: 1; }
    .domain-text { font-size: 0.28rem; color: #999; }
  }
  
  .logout-btn {
    position: absolute;
    bottom: 0.4rem;
    left: 0.4rem;
    right: 0.4rem;
    background: #f0f0f0;
    border-radius: 0.6rem;
    padding: 0.24rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.12rem;
    cursor: pointer;
    
    img { width: 0.44rem; object-fit: contain; }
  }
}

// 弹窗
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  
  .modal-container {
    position: relative;
    background: #fff;
    border-radius: 0.2rem;
    width: 80%;
    max-width: 7rem;
    
    .modal-close {
      position: absolute;
      top: 0.16rem;
      right: 0.16rem;
      width: 0.5rem;
      cursor: pointer;
    }
    
    .modal-body { padding: 0.6rem; text-align: center; font-size: 0.36rem; }
    .modal-btn {
      display: block;
      margin: 0 auto 0.6rem;
      width: 2.2rem;
      text-align: center;
      background: linear-gradient(135deg, #3b82f6, #2563eb);
      color: #fff;
      padding: 0.12rem 0;
      border: none;
      border-radius: 0.6rem;
      cursor: pointer;
    }
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// src/components/mode/index.vue